import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const Pencil = ({ svgSize = ICON_SIZES.MD, className = '' }) => {
  const { theme } = useContext(BrandContext);
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5861 21.1593L7.28631 17.8594L17.3658 7.78012L23.9655 14.3798L13.8859 24.4591L10.5861 21.1593Z"
          fill={theme.icon.fill}
        />
        <path
          d="M19.7319 4.47125C20.5129 3.69051 21.7791 3.69051 22.5601 4.47125L27.2739 9.18512C28.0548 9.96609 28.0547 11.2322 27.2739 12.0132L14.3579 24.9302C14.2597 25.0284 14.1325 25.0939 13.9956 25.1168L8.69873 25.9996H27.3335C27.7014 25.9998 28.0004 26.2986 28.0005 26.6666C28.0005 27.0346 27.7015 27.3333 27.3335 27.3336H6.00049C5.6323 27.3336 5.3335 27.0348 5.3335 26.6666C5.33353 26.4172 5.47141 26.2019 5.67432 26.0875C5.45178 25.87 5.32916 25.5512 5.38623 25.2086L6.62842 17.7496C6.65132 17.6127 6.71683 17.4854 6.81494 17.3873L19.7319 4.47125ZM6.99463 23.6617L8.08252 24.7496L12.4985 24.0142L7.73193 19.2466L6.99463 23.6617ZM11.5288 21.1588L13.8862 23.5162L23.0532 14.3502L20.6714 12.0162L11.5288 21.1588ZM8.229 17.8599L10.5864 20.2164L19.7192 11.0836L17.3384 8.75055L8.229 17.8599ZM21.6167 5.41461C21.3564 5.15457 20.9356 5.15457 20.6753 5.41461L18.2817 7.80719L23.9966 13.4068L26.3315 11.0709C26.5916 10.8105 26.5908 10.3888 26.3306 10.1285L21.6167 5.41461Z"
          fill={theme.icon.stroke}
        />
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3718 31.7603L10.5339 32.2198L29.9204 12.8333L42.2948 25.2076L22.8742 44.6282L23.3576 42.7521C23.5479 42.0137 22.9903 41.2943 22.2278 41.2943H20.5968C20.0264 41.2943 19.5397 40.882 19.446 40.3194L18.9216 37.1733C18.8391 36.6783 18.4493 36.2915 17.9537 36.2129L14.7917 35.7111C14.2214 35.6206 13.8032 35.1266 13.8079 34.5493L13.8214 32.9017C13.8276 32.1388 13.112 31.5752 12.3718 31.7603Z"
        fill={theme.icon.fill}
      />
      <path
        d="M33.0627 8.67816C34.3156 7.42554 36.347 7.42554 37.5999 8.67816L46.675 17.7534C47.9274 19.0062 47.9273 21.0367 46.675 22.2895L23.9543 45.0102C23.825 45.1395 23.6583 45.2256 23.4778 45.2553L20.2229 45.7914H45.5002C45.9833 45.7916 46.3751 46.1834 46.3752 46.6664C46.3752 47.1496 45.9833 47.5413 45.5002 47.5414H9.60181L9.46509 47.5639C8.48017 47.7259 7.62703 46.8721 7.78931 45.8871L8.59106 41.0239L10.0979 31.8754C10.1276 31.6951 10.2129 31.5282 10.342 31.3989L33.0627 8.67816ZM13.0452 32.3725L11.7356 32.6987L10.3899 40.8657L14.4875 44.9633L22.6301 43.6205L22.9719 42.2973C23.0193 42.1129 22.88 41.9334 22.6897 41.933H21.0579C20.06 41.9329 19.2084 41.2112 19.0442 40.227L18.5198 37.0805C18.499 36.957 18.4013 36.861 18.2776 36.8412L15.1155 36.3383C14.1179 36.1798 13.3867 35.3161 13.3948 34.3061L13.4075 32.6577C13.4087 32.4672 13.23 32.3263 13.0452 32.3725ZM22.1819 40.1821H22.6897C23.6946 40.1823 24.4957 40.8975 24.6877 41.8022L41.5188 24.9711L39.4563 22.9086L22.1819 40.1821ZM16.094 34.7221L18.552 35.1118C19.4194 35.2494 20.102 35.9271 20.2463 36.7934L20.6545 39.2358L38.219 21.6713L33.6819 17.1342L16.094 34.7221ZM13.5549 30.6616C14.4578 30.8611 15.1655 31.6674 15.1575 32.6723L15.1545 33.187L32.4446 15.8969L30.3821 13.8344L13.5549 30.6616ZM36.3625 9.91547C35.7932 9.34635 34.8705 9.34653 34.301 9.91547L31.6194 12.5971L42.7561 23.7338L45.4377 21.0522C46.0066 20.4828 46.0067 19.56 45.4377 18.9907L36.3625 9.91547Z"
        fill={theme.icon.stroke}
      />
    </svg>
  );
};

Pencil.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Pencil;
